import { render, staticRenderFns } from "./CelatList.vue?vue&type=template&id=3d0cd3ec&scoped=true&"
import script from "./CelatList.vue?vue&type=script&lang=js&"
export * from "./CelatList.vue?vue&type=script&lang=js&"
import style0 from "./CelatList.vue?vue&type=style&index=0&id=3d0cd3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cd3ec",
  null
  
)

export default component.exports